import { render, staticRenderFns } from "./ExpenseTabs.vue?vue&type=template&id=31402d16&"
import script from "./ExpenseTabs.vue?vue&type=script&lang=js&"
export * from "./ExpenseTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports